import drupalParams from 'src/lib/common/data/drupalParams';
import { filesByLanguage, languageByLocale, type Language, type WheelTextFiles } from './wheelTextFiles';

export type WheelTextVariant = keyof WheelTextFiles;

// The cache-busting query string Drupal adds to app.js, so each deploy refreshes the files.
const cacheBuster = new URL(import.meta.url).search;

async function download(url: string) {
  const response = await fetch(url + cacheBuster);
  if (!response.ok) {
    throw new Error(`${response.status} ${url}`);
  }
  return response.text();
}

async function loadWheelText(language: Language) {
  const files = filesByLanguage[language];
  const [full, preview, wizard] = await Promise.all([
    download(files.full),
    download(files.preview),
    download(files.wizard),
  ]);
  return { language, markup: { full, preview, wizard } };
}

const language = languageByLocale[drupalParams.locale] ?? 'en';

// Awaited before the app renders, so a wheel is never shown without its text.
const wheelText = await loadWheelText(language).catch((error) => {
  console.error('Taste wheel text failed to load.', error);
  return loadWheelText('en');
});

export default wheelText;
